/* Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. */

import { FancyAction } from 'src/app/common/fancy-firebase/base/FancyAction';
import { FancyActionableFirebase } from 'src/app/common/fancy-firebase/generics/FancyActionableFirebase';
import { OrganizationMemberList } from 'src/app/common/fancy-firebase/lists/OrganizationMemberList';
import { OrganizationMember } from '../models/OrganizationMember';

export class OrganizationMembersApi extends FancyActionableFirebase<
	OrganizationMember,
	FancyAction,
	OrganizationMemberList
> {
	constructor(public data: OrganizationMemberList) {
		super(data);
	}
}
